const TextInputFilterComponent = {
    templateUrl: '/ui/advancedFilter/component/textInputFilter/textInputFilter.tpl.html',
    controller: 'textInputFilterController',
    bindings: {
        criterionTemplate: '<',
        advancedFilterType: '<',
        translationsKey: '<?',
        disableAutoFocus: '<?'
    }
};

angular.module('umCore')
    .component('uiTextInputFilter', TextInputFilterComponent);
